export default __webpack_public_path__ + "static/media/wp-shorter.160c13ed.gif";